import React, { useMemo } from 'react';

import { alpha, makeStyles } from '@gogame/components';

const useStyles = makeStyles((theme) => ({
  highlight: {
    background: alpha(
      theme.palette.primary.main,
      theme.palette.action.disabledOpacity
    ),
  },
}));

const Highlights = ({ text, highlight }) => {
  const classes = useStyles();

  return useMemo(() => {
    return highlight
      ? text
          ?.replaceAll(
            new RegExp(highlight, 'gi'),
            (highlightSubtext) => `<>${highlightSubtext}<>`
          )
          .split('<>')
          .map((subtext, i) => (
            <React.Fragment key={i}>
              {subtext.toLowerCase() === highlight.toLowerCase() ? (
                <span className={classes.highlight}>{subtext}</span>
              ) : (
                subtext
              )}
            </React.Fragment>
          ))
      : text;
  }, [text, highlight]);
};

export default Highlights;
